// @ts-nocheck

import { useEffect, useState } from "react";
import { PMGrid, PMText } from "lib";

import { setStore } from "store/appSlice";
import { useDispatch } from "react-redux";
function POSPKyc() {
    // Hold page variables to avoid polluting variable space
    var page = {
        data: {},
        parameters: {
            route: {},
        },
    };

    const dispatch = useDispatch();
    dispatch(setStore({ currentPageTitle: "" }));

    return (
        <div className="builder_wrapper">
            <PMGrid
                item={true}
                container={true}
                md={3}
                background="#007493"
                sx={{
                    direction: "column",
                    width: "85vw",
                    minWidth: "85vw",
                    height: "90vh",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <PMText children="Feature Disabled" variant="h3" sx={{ opacity: ".5" }} color="info"></PMText>
            </PMGrid>
        </div>
    );
}
export default POSPKyc;
